import Behaviour, { mix } from '@/core'
import { Route } from '@/core/router'
import SponLax from 'sponlax'
import resizer from 'spon-resize'

export default class ScrollMotion extends mix(Behaviour).with(Route) {
	mounted = () => {
		this.screen = resizer()

		this.screen.start()

		this.withRoutes()

		this.selector = '[data-motion="scroll"]'
		this.mid = this.screen.height / 2
		
		const $nodeArray = [...document.querySelectorAll(this.selector)]

		this.options = {
			rootMargin: '0px',
			shouldUnObserve: () => false,
			inview: $node => {
				// const { speed } = $node.dataset

				// if (speed) {
				// 	const { top, height } = $node.getBoundingClientRect()
				// 	const y = (this.mid - (top + height / 2)) * parseFloat(speed)

				// 	$node.style.transform = `translate3d(0, ${y}px, 0)`
				// }
				const { top } = $node.getBoundingClientRect()
				
				// set the inital top value if it has not already been set
				if (typeof $node._initialTop === 'undefined') {
					$node._initialTop = top
				}
				
				// subtract the offset by the initial value, to prevent it from jumping on load
				const y = (top - $node._initialTop) * -0.1
				$node.style.transform = `translate3d(0, ${y}px, 0)`
			}
		}

		this.lax = null
		this.screen.at('(min-width: 48em)', {
			match: () => {
				this.testForViewportTop($nodeArray)
				this.lax = new SponLax(this.selector, this.options)
			},
			unmatch: () => {
				if (this.lax) {
					this.lax.disconnect()
					this.lax = null
					;[...document.querySelectorAll(this.selector)].forEach(item => {
						item.style.transform = ''
					})
				}
			}
		})
	}

	testForViewportTop = ($nodeArray) => {
		this.mid = this.screen.height / 2

		$nodeArray.forEach($node => {
			const { speed } = $node.dataset

			const { top, height } = $node.getBoundingClientRect()
			const y = (this.mid - (top + height / 2)) * parseFloat(speed)

			if(top === 0) $node.style.top = `${-y}px`
		})
	}

	onChange = () => {
		this.lax && this.lax.disconnect()
	}

	onComplete = () => {
		this.lax && this.lax.update(this.selector, this.options)
	}
}
